import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const ImpersonationBanner = () => {
  const { usuario } = useAuth();
  
  // Verificar se está em modo de impersonificação
  const isImpersonating = localStorage.getItem('impersonacao') === 'true';
  
  if (!isImpersonating) {
    return null;
  }

  const handleExitImpersonation = () => {
    // Remover dados de impersonificação
    localStorage.removeItem('impersonacao');
    localStorage.removeItem('token');
    
    // Recarregar página para voltar ao painel de admin
    window.location.href = '/admin/usuarios';
  };

  return (
    <div className="bg-purple-600 text-white p-3 text-center relative z-50">
      <div className="flex items-center justify-center space-x-4">
        <div className="flex items-center space-x-2">
          <span className="text-lg">🔄</span>
          <span className="font-medium">
            Você está navegando como: <strong>{usuario?.nome}</strong> ({usuario?.email})
          </span>
        </div>
        
        <button
          onClick={handleExitImpersonation}
          className="bg-purple-700 hover:bg-purple-800 px-4 py-1 rounded-lg transition-colors text-sm font-medium"
        >
          ✕ Sair da Impersonificação
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner; 